export default function QuestionTypeField({ title, children }) {
    return (
        <div className="question-type-field">
            <p className="question-type-field__label">{ title }</p>
            { children }
        </div>
    )
}